import React, { useEffect, useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

const inp = "w-full px-3 py-2.5 rounded-xl border border-brand-soft bg-white outline-none focus:border-brand-lime text-sm text-brand-greenDeep";

export default function ReferentApplyForm() {
  const [types, setTypes] = useState([]);
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", mobile: "", phone: "", city: "", postal_code: "", zones: "", profession: "", bio: "", missions: [] });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { api.get("/referents/mission-types-public").then((r) => setTypes(r.data.mission_types || [])).catch(() => {}); }, []);
  const toggle = (k) => setForm((f) => ({ ...f, missions: f.missions.includes(k) ? f.missions.filter((x) => x !== k) : [...f.missions, k] }));

  const submit = async () => {
    if (!form.first_name.trim() || !form.email.trim()) { toast.error("Prénom et e-mail requis"); return; }
    setBusy(true);
    try { await api.post("/referents/apply", form); setDone(true); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="text-center py-10 bg-white rounded-3xl border border-brand-soft" data-testid="referent-apply-done">
        <div className="w-14 h-14 rounded-2xl bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center mx-auto"><ShieldCheck className="w-7 h-7" /></div>
        <p className="font-semibold text-brand-greenDeep mt-4 text-lg">Candidature envoyée !</p>
        <p className="text-sm text-brand-green/60 mt-1 max-w-md mx-auto">Notre équipe étudie votre profil et vous recontacte après validation. À très vite !</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-3xl border border-brand-soft p-6 sm:p-8" data-testid="referent-apply-form">
      <h3 className="font-display text-2xl font-semibold text-brand-greenDeep">Proposer ma candidature</h3>
      <p className="text-sm text-brand-green/60 mt-1">Renseignez votre profil : notre équipe revient vers vous après validation.</p>
      <div className="space-y-3 mt-5">
        <div className="grid sm:grid-cols-2 gap-3">
          <input value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} placeholder="Prénom" className={inp} data-testid="apply-firstname" />
          <input value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} placeholder="Nom" className={inp} data-testid="apply-lastname" />
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="E-mail" className={inp} data-testid="apply-email" />
          <input value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} placeholder="Mobile" className={inp} data-testid="apply-mobile" />
          <input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="Ville" className={inp} data-testid="apply-city" />
          <input value={form.postal_code} onChange={(e) => setForm({ ...form, postal_code: e.target.value })} placeholder="Code postal" className={inp} />
          <input value={form.profession} onChange={(e) => setForm({ ...form, profession: e.target.value })} placeholder="Profession / statut" className={inp} />
          <input value={form.zones} onChange={(e) => setForm({ ...form, zones: e.target.value })} placeholder="Zones d'intervention" className={inp} />
        </div>
        <textarea value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} placeholder="Présentez-vous en quelques mots" className={inp} rows={2} />
        <div>
          <p className="text-xs font-medium text-brand-green/70 mb-2">Missions que vous pouvez réaliser</p>
          <div className="flex flex-wrap gap-2">
            {types.map((t) => (
              <button key={t.key} type="button" onClick={() => toggle(t.key)} className={`px-3 py-1.5 rounded-full text-xs font-semibold border ${form.missions.includes(t.key) ? "bg-brand-greenDeep text-white border-brand-greenDeep" : "bg-white text-brand-greenDeep border-brand-soft"}`} data-testid={`apply-mission-${t.key}`}>{t.label}</button>
            ))}
          </div>
        </div>
        <button onClick={submit} disabled={busy} className="w-full py-3 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white font-semibold disabled:opacity-60" data-testid="apply-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Envoyer ma candidature"}</button>
        <p className="text-[11px] text-brand-green/40 text-center">Candidature soumise à validation par l'équipe avant toute mission.</p>
      </div>
    </div>
  );
}
